import Select, { SingleValue } from "react-select";
import { Button } from "../../../../../components/ui/button";
import { useSellerTransactionFilter } from "./useSellerTransactionFilter";
import { FilterSelectStyle } from "../../../../../components/BasicFilter/FilterSelectStyle";
import { BasicFilter } from "../../../../../components/BasicFilter";
import { optionsStatusSelect } from "../../../../../../app/utils/status";
import { DateRangePicker } from "@/view/components/DateRangePicker";
import { PartnerType } from "@/app/utils/partners.enum";
import { useProductsCatalog } from "@/app/hooks/useProductsCatalog";

export const SellerTransactionFilter = () => {
  const { getProductLabel } = useProductsCatalog();

  const optionsTypeSelect = Object.values(PartnerType).map((product) => ({
    value: product,
    label: getProductLabel(product),
  }));

  const {
    errors,
    handleClearFilter,
    handleFilterSubmit,
    handleSelectCustomer,
    handleSelectStatus,
    handleSelectType,
    selectedCustomerOptions,
    selectedStatusOptions,
    selectedTypeOption,
    isSubmitting,
    customerOptions,
    handleLoadMoreCustomer,
    isFetchingCustomer,
    isLoadingCustomer,
    selectedDate,
    handleDateChange,
  } = useSellerTransactionFilter();

  const { DropdownIndicator, customStyles } = FilterSelectStyle({
    isMulti: true,
  });

  const { customStyles: singleSelectStyles } = FilterSelectStyle({
    isMulti: false,
  });

  return (
    <div className="flex items-center justify-between">
      <BasicFilter>
        <form onSubmit={handleFilterSubmit}>
          <div className="px-4">
            <h2 className="mb-2 font-medium text-black04">Data</h2>
            <DateRangePicker
              date={selectedDate}
              onDateChange={handleDateChange}
              numberOfMonths={1}
            />
          </div>
          <div className="space-y-4 p-4">
            <div className="space-y-2">
              <h3 className="font-medium text-black04">Cliente</h3>
              <Select
                isMulti
                options={customerOptions}
                onChange={handleSelectCustomer}
                value={selectedCustomerOptions}
                placeholder="Selecione o(s) cliente(s)"
                styles={customStyles}
                components={{
                  IndicatorSeparator: () => null,
                  DropdownIndicator,
                }}
                isLoading={isFetchingCustomer || isLoadingCustomer}
                onMenuScrollToBottom={handleLoadMoreCustomer}
              />
              {errors.customerIds?.message}
            </div>

            <div className="space-y-2">
              <h3 className="font-medium text-black04">Status</h3>
              <Select
                options={optionsStatusSelect}
                isMulti
                onChange={handleSelectStatus}
                value={selectedStatusOptions}
                placeholder="Selecione o(s) status"
                styles={customStyles}
                components={{
                  IndicatorSeparator: () => null,
                  DropdownIndicator,
                }}
              />
              {errors.status?.message}
            </div>

            <div className="space-y-2">
              <h3 className="font-medium text-black04">Produto</h3>
              <Select
                options={optionsTypeSelect}
                onChange={(option) =>
                  handleSelectType(
                    option as SingleValue<{ value: string; label: string }>,
                  )
                }
                value={selectedTypeOption}
                placeholder="Selecione o produto"
                styles={singleSelectStyles}
                components={{
                  IndicatorSeparator: () => null,
                  DropdownIndicator,
                }}
                isClearable
              />
              {errors.type?.message}
            </div>
          </div>
          <div className="my-5 w-full border-b-[1px] border-gray01" />
          <div className="flex items-center justify-between p-4">
            <Button
              onClick={handleClearFilter}
              variant="outline"
              className="w-24 rounded-full bg-gray02 text-xs font-bold"
            >
              Limpar
            </Button>
            <Button
              type="submit"
              disabled={isSubmitting}
              className="w-20 rounded-full bg-primary text-xs font-bold text-white01"
            >
              Filtrar
            </Button>
          </div>
        </form>
      </BasicFilter>
    </div>
  );
};
